import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Form} from 'react-bootstrap'
import {LoadingComponent, Auth} from 'recupero-comunes'
import {useFormik} from 'formik'
import {validationSchemas} from '../../common/validation-Schemas-confirmaingreso'
import Formulario from './formulario'
import { configuracionFormAction36, postConfirmarRecobro,antecedentesRecobro, AntecedentesRecobro } from '../../store/actions/confirmar-ingreso-recobro'

const ConfirmarIngreso = () => {
    
    const {rutUsuario} = Auth.currentUser()
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado
    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)

    const data_confirmar = useSelector((state) => state.confirmarIngresoRecobroReducer)
    const {antecedentesRecobro} = data_confirmar
    useEffect(() => {
        if(llaves){ 
        setLoading(true)
         let query = Buffer.from(JSON.stringify({
             rutcia: llaves && llaves['idOrgCaso'],
             idform: 36
         })).toString('base64')
         dispatch(configuracionFormAction36(query))
         .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idCaso": llaves && llaves["idCaso"],
                "idImplicado": llaves && llaves["idImplicado"]
            })).toString('base64')
            dispatch(AntecedentesRecobro(query))
         })
         .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": '',
            "idOrganizacion": '',
            "fechaOcurrencia":"",
            "comentario": '',
            "idUsuario": '',
             
        },
        validationSchema: validationSchemas(),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }

            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] =rutUsuario && rutUsuario
            dataForm['saldoRecobro'] = antecedentesRecobro && antecedentesRecobro.antecedentesRecobro['saldoRecobro'];
            
            setLoading(true)
            dispatch(postConfirmarRecobro(dataForm)).then(()=>setLoading(false))            
            handleShowToast()
        }
    })
    return (
        <div>
            <LoadingComponent show={loading}/>  
            <Form onSubmit={formik.handleSubmit}>
                <Formulario formik={formik}
                    showToast={showToast}
                    setShowToast={setShowToast}
                    loading={loading}
                />
            </Form>
        </div>
    )
}

export default ConfirmarIngreso
